import type { PublicApiError } from './types';

const ERROR_MESSAGES: Record<string, string> = {
  INVALID_TOKEN: 'Token inválido. Contacta soporte.',
  TOKEN_EXPIRED: 'El token expiró. Solicita uno nuevo.',
  DOMAIN_NOT_ALLOWED: 'Este widget no está configurado para este dominio.',
  RATE_LIMITED: 'Has enviado demasiados mensajes. Intenta más tarde.',
  VALIDATION_ERROR: 'Error de validación. Revisa tu mensaje.',
  INVALID_REQUEST: 'La solicitud no es válida.',
  BACKEND_UNAVAILABLE: 'El servidor no está disponible. Intenta más tarde.',
  INTERNAL_ERROR: 'Algo salió mal. Por favor intenta de nuevo.',
  NETWORK_ERROR: 'Error de conexión. Verifica tu conexión.',
  TIMEOUT_ERROR: 'La solicitud tardó demasiado. Intenta de nuevo.',
  LOCAL_RATE_LIMITED: 'Demasiadas solicitudes en poco tiempo. Espera un momento.',
  INSECURE_ORIGIN: 'El widget requiere un dominio HTTPS válido.',
};

export function mapErrorToUserMessage(error: PublicApiError | string): string {
  if (typeof error === 'string') {
    return ERROR_MESSAGES[error] || ERROR_MESSAGES.INTERNAL_ERROR;
  }

  const userMessage = ERROR_MESSAGES[error.errorCode];
  return userMessage || ERROR_MESSAGES.INTERNAL_ERROR;
}

export class WidgetError extends Error {
  constructor(
    public errorCode: string,
    public userMessage: string,
    message?: string,
  ) {
    super(message || userMessage);
    this.name = 'WidgetError';
  }
}

export function createWidgetError(errorCode: string, message?: string): WidgetError {
  const userMessage = mapErrorToUserMessage(errorCode);
  return new WidgetError(errorCode, userMessage, message);
}
